// L'indicateur d'état de synchronisation, toujours visible (R-OFF-05).
import { useNavigate } from 'react-router';
import { useMagasin, magasin } from '../donnees/magasin';

const LIBELLES: Record<string, string> = {
  a_jour: 'À jour',
  en_attente: 'en attente',
  synchronisation: 'Synchronisation…',
  hors_ligne: 'Hors ligne',
  reconnexion: 'Reconnexion nécessaire',
  erreur: 'Erreur de synchronisation',
};

export function IndicateurSync() {
  const { statutSync, enAttente, erreurSync, derniereSync } = useMagasin();
  const naviguer = useNavigate();
  const libelle = statutSync === 'en_attente' || (statutSync === 'hors_ligne' && enAttente) ? `${enAttente} changement${enAttente > 1 ? 's' : ''} ${statutSync === 'hors_ligne' ? 'à envoyer (hors ligne)' : 'en attente'}` : LIBELLES[statutSync];
  const titre = [erreurSync, derniereSync ? `Dernière synchronisation : ${new Date(derniereSync).toLocaleString('fr-FR')}` : undefined, 'Cliquer pour synchroniser'].filter(Boolean).join('\n');
  const action = () => {
    if (statutSync === 'reconnexion') naviguer('/connexion');
    else void magasin.synchroniser();
  };
  return (
    <button className={`indicateur-sync ${statutSync}`} title={titre} onClick={action} aria-live="polite">
      <span className="point" aria-hidden="true" /> {libelle}
    </button>
  );
}
